import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  IEventCollectionData,
  IEventCollectionDataActiveTypeticketcollections,
  IEventCollectionMetadata
} from 'meta/pages/v4/eventCollection'

import Head from 'components/common/Head'

interface Props {
  details: IEventCollectionData
  activeTypeticketCollections: {
    data: Record<number, IEventCollectionDataActiveTypeticketcollections>
    metadata: IEventCollectionMetadata
  }
}

const CollectionHead: React.FC<Props> = (props) => {
  const { details, activeTypeticketCollections } = props

  const { t } = useTranslation()

  const title = String(
    t(`collection:head_og_title${activeTypeticketCollections.metadata.total > 0 ? '_season' : ''}`, { name: details.name })
  )

  const description = String(
    t(`collection:head_og_description${activeTypeticketCollections.metadata.total > 0 ? '_season' : ''}`, { name: details.name })
  )

  const coverImage = details.assets.filter((x) => x.format == 'square')[0]?.url

  return (
    <Head>
      <title>{title}</title>

      <meta property="og:type" content="article" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={`${window.location.href}`} />
      <meta property="og:image" content={coverImage} />
      <meta property="og:site_name" content="TicketSms.it" />
      <meta property="og:locale" content="it_IT" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@TicketSms.it" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={coverImage} />
      <meta name="twitter:creator" content="@TicketSms" />
    </Head>
  )
}

export default CollectionHead
